// TODO : passer en preval

const sirnc = [
  { code: 'S', value: 'S - Sensible', index: 0 },
  { code: 'I', value: 'I - Intermédiaire', index: 1 },
  { code: 'R', value: 'R - Résistant', index: 2 },
  { code: 'NC', value: 'NC - Non connu', index: 3 }
]

const ssfprnc = [
  { code: 'S', value: 'S - Sensible', index: 0 },
  { code: 'SFP', value: 'SFP - Sensible à forte posologie', index: 5 },
  { code: 'R', value: 'R - Résistant', index: 2 },
  { code: 'NC', value: `NC - Non connu ou zone d'incertitude technique`, index: 3 }
]

const rktgList = [
  {
    code: 'O',
    value: 'O - Résistance à kanamycine, tobramycine et gentamicine',
    index: 0
  },
  {
    code: 'N',
    value: 'N - Sensibilité à kanamycine, tobramycine et gentamicine',
    index: 1
  },
  {
    code: 'NC',
    value: 'NC - Non connu',
    index: 2
  }
]

const oxaList = {
  v1: [
    { code: 'S', value: 'S - Sensible', index: 0 },
    { code: 'I/R', alt: 'R', value: 'I/R - Intermédiaire ou résistant', index: 1 },
    { code: 'NC', value: 'NC - Statut SARM ou SASM non connu', index: 2 }
  ],

  v2: ssfprnc
}

const glyList = {
  v1: sirnc,
  v2: ssfprnc
}

const panList = {
  v1: [
    {
      code: 'N',
      index: 0,
      value: 'N - Sensibilité à au moins un antibiotique testé'
    },
    {
      code: 'P',
      index: 1,
      value: 'P - Intermédiaire ou résistant à tous les antibiotiques testés'
    },
    {
      code: 'C',
      index: 2,
      value: 'C - Intermédiaire ou résistant à tous les antibiotiques testés, confirmé par laboratoire de référence'
    },
    {
      code: 'NC',
      index: 3,
      value: 'NC - Non connu'
    }
  ],
  v2: [
    {
      code: 'N',
      index: 0,
      value: 'N - Sensibilité à au moins un antibiotique testé'
    },
    {
      code: 'P',
      index: 1,
      value: 'P - Résistant à tous les antibiotiques testés'
    },
    {
      code: 'C',
      index: 2,
      value: 'C - Résistant à tous les antibiotiques testés, confirmé par laboratoire de référence'
    },
    {
      code: 'NC',
      index: 3,
      value: 'NC - Non connu'
    }
  ]
}

const c3gList = {
  v1: sirnc,
  v2: ssfprnc
}

const carList = {
  v1: sirnc,
  v2: ssfprnc
}

function onnc (germ, masc, text) {
  const productor = masc ? 'producteur' : 'productrice'
  return [
    { code: 'O', value: `O - ${germ} ${productor} de ${text}`, index: 0 },
    {
      code: 'N',
      value: `N - ${germ} non ${productor} de ${text}`,
      index: 1
    },
    { code: 'NC', value: 'NC - Non connu', index: 2 }
  ]
}
const blseList = onnc('Entérobactérale', false, 'BLSE')
const epcList = onnc('Entérobactérale', false, 'carbapénémase')
const epcTypeList = [
  { code: 1, index: 1, value: '1. KPC' },
  { code: 2, index: 2, value: '2. OXA 48' },
  { code: 3, index: 3, value: '3. NDM' },
  { code: 4, index: 4, value: '4. VIM' },
  { code: 5, index: 5, value: '5. IMP' },
  { code: 9, index: 9, value: '9. Non connu' }
]
const cazList = {
  v1: sirnc,
  v2: ssfprnc
}
const ppcList = onnc('P. aeruginosa', true, 'carbapénémase')
const ppcTypeList = [
  { code: 3, index: 3, value: '3. NDM' },
  { code: 4, index: 4, value: '4. VIM' },
  { code: 5, index: 5, value: '5. IMP' },
  { code: 6, index: 6, value: '6. GES' },
  { code: 9, index: 9, value: '9. Non connu' }
]

const fluList = [
  {
    code: 'S',
    index: 0,
    value: 'S - Sensible'
  },
  {
    code: 'SDD-R',
    alt: 'R',
    index: 1,
    value: 'SDD-R - Sensibilité dose dépendante ou Résistant'
  },
  {
    code: 'NC',
    index: 2,
    value: 'NC - Non connu'
  }
]

const initialList = [
  {
    value: 'STA AUR - Staphylococcus aureus',
    code: 'STA AUR',
    ecdc: 'STAAUR',
    index: 0
  },
  {
    value: 'STA EPI - Staphylococcus epidermidis',
    code: 'STA EPI',
    ecdc: 'STAEPI',
    index: 1
  },
  {
    value: 'STA HAE - Staphylococcus haemolyticus',
    code: 'STA HAE',
    ecdc: 'STAHAE',
    index: 2
  },
  {
    value: 'STA CAP - Staphylococcus capitis',
    code: 'STA CAP',
    ecdc: 'STAOTH',
    index: 3
  },
  {
    value: 'STA AUT - Staph. à coagulase négative : autre espèce identifiée',
    code: 'STA AUT',
    ecdc: 'STAOTH',
    index: 4
  },
  {
    value: 'STA NSP - Staph. à coagulase négative non spécifié',
    code: 'STA NSP',
    ecdc: 'STACNS',
    index: 5
  },
  {
    value: 'STR PNE - Streptococcus pneumoniae (pneumocoque)',
    code: 'STR PNE',
    ecdc: 'STRPNE',
    index: 6
  },
  {
    value: 'STR AGA - Streptococcus agalactiae (B)',
    code: 'STR AGA',
    ecdc: 'STRAGA',
    index: 7
  },
  {
    value: 'STR PYO - Streptococcus pyogenes (A)',
    code: 'STR PYO',
    ecdc: 'STRPYO',
    index: 8
  },
  {
    value: 'STR HCG - Streptocoques hémolytiques : autres (C, G)',
    code: 'STR HCG',
    ecdc: 'STRHCG',
    index: 9
  },
  {
    value: 'STR NGR - Streptocoques (viridans) non groupables',
    code: 'STR NGR',
    ecdc: 'STROTH',
    index: 10
  },
  {
    value: 'STR AUT - Streptocoques autres',
    code: 'STR AUT',
    ecdc: 'STROTH',
    index: 11
  },
  {
    value: 'ENC FAE - Enterococcus faecalis',
    code: 'ENC FAE',
    ecdc: 'ENCFAE',
    index: 12
  },
  {
    value: 'ENC FAI - Enterococcus faecium',
    code: 'ENC FAI',
    ecdc: 'ENCFAI',
    index: 13
  },
  {
    value: 'ENC AUT - Enterococcus autres',
    code: 'ENC AUT',
    ecdc: 'ENCOTH',
    index: 14
  },
  {
    value: 'ENC NSP - Enterococcus non spécifié',
    code: 'ENC NSP',
    ecdc: 'ENCNSP',
    index: 15
  },
  {
    value: 'CGP AUT - Cocci Gram + : autres',
    code: 'CGP AUT',
    ecdc: 'GPCOTH',
    index: 16
  },
  {
    value: 'MOR SPP - Moraxella',
    code: 'MOR SPP',
    ecdc: 'MOROTH',
    index: 17
  },
  {
    value: 'NEI MEN - Neisseria meningitidis',
    code: 'NEI MEN',
    ecdc: 'NEIMEN',
    index: 18
  },
  {
    value: 'NEI AUT - Neisseria autres',
    code: 'NEI AUT',
    ecdc: 'NEIOTH',
    index: 19
  },
  {
    value: 'CGN AUT - Cocci Gram - : autres',
    code: 'CGN AUT',
    ecdc: 'GNCOTH',
    index: 20
  },
  {
    value: 'COR SPP - Corynebacterium',
    code: 'COR SPP',
    ecdc: 'CORSPP',
    index: 21
  },
  {
    value: 'BAC CER - Bacillus cereus',
    code: 'BAC CER',
    ecdc: 'BACSPP',
    index: 22
  },
  {
    value: 'BAC SPP - Bacillus autres',
    code: 'BAC SPP',
    ecdc: 'BACSPP',
    index: 23
  },
  {
    value: 'LAC SPP - Lactobacillus',
    code: 'LAC SPP',
    ecdc: 'LACSPP',
    index: 24
  },
  {
    value: 'LIS MON - Listeria monocytogenes',
    code: 'LIS MON',
    ecdc: 'LISMON',
    index: 25
  },
  {
    value: 'BGP AUT - Bacilles Gram + : autres',
    code: 'BGP AUT',
    ecdc: 'GPBOTH',
    index: 26
  },
  {
    value: 'CIT FRE - Citrobacter freundii',
    code: 'CIT FRE',
    ecdc: 'CITFRE',
    index: 27
  },
  {
    value: 'CIT KOS - Citrobacter koseri (ex. diversus)',
    code: 'CIT KOS',
    ecdc: 'CITDIV',
    index: 28
  },
  {
    value: 'CIT AUT - Citrobacter autres',
    code: 'CIT AUT',
    ecdc: 'CITOTH',
    index: 29
  },
  {
    value: 'ENT AER - Enterobacter aerogenes ou Klebsiella aerogenes',
    code: 'ENT AER',
    ecdc: 'ENBAER',
    index: 30
  },
  {
    value: 'ENT CLO - Enterobacter cloacae',
    code: 'ENT CLO',
    ecdc: 'ENBCLO',
    index: 31
  },
  {
    value: 'ENT AUT - Enterobacter autres',
    code: 'ENT AUT',
    ecdc: 'ENBOTH',
    index: 32
  },
  {
    value: 'ESC COL - Escherichia coli',
    code: 'ESC COL',
    ecdc: 'ESCCOL',
    index: 33
  },
  {
    value: 'HAF SPP - Hafnia',
    code: 'HAF SPP',
    ecdc: 'HAFSPP',
    index: 34
  },
  {
    value: 'KLE OXY - Klebsiella oxytoca',
    code: 'KLE OXY',
    ecdc: 'KLEOXY',
    index: 35
  },
  {
    value: 'KLE PNE - Klebsiella pneumoniae',
    code: 'KLE PNE',
    ecdc: 'KLEPNE',
    index: 36
  },
  {
    value: 'KLE AUT - Klebsiella autres',
    code: 'KLE AUT',
    ecdc: 'KLEOTH',
    index: 37
  },
  {
    value: 'MOG SPP - Morganella',
    code: 'MOG SPP',
    ecdc: 'MOGSPP',
    index: 38
  },
  {
    value: 'PRT MIR - Proteus mirabilis',
    code: 'PRT MIR',
    ecdc: 'PRTMIR',
    index: 39
  },
  {
    value: 'PRT AUT - Proteus autres',
    code: 'PRT AUT',
    ecdc: 'PRTOTH',
    index: 40
  },
  {
    value: 'PRV SPP - Providencia',
    code: 'PRV SPP',
    ecdc: 'PRVSPP',
    index: 41
  },
  {
    value: 'SAL TYP - Salmonella Typhi ou Paratyphi',
    code: 'SAL TYP',
    ecdc: 'SALTYP',
    index: 42
  },
  {
    value: 'SAL AUT - Salmonella autre',
    code: 'SAL AUT',
    ecdc: 'SALOTH',
    index: 43
  },
  {
    value: 'SER SPP - Serratia',
    code: 'SER SPP',
    ecdc: 'SERSPP',
    index: 44
  },
  {
    value: 'SHI SPP - Shigella',
    code: 'SHI SPP',
    ecdc: 'SHISPP',
    index: 45
  },
  {
    value: 'ETB AUT - Entérobactérales : autres',
    code: 'ETB AUT',
    ecdc: 'ETBOTH',
    index: 46
  },
  {
    value: 'ACH SPP - Achromobacter',
    code: 'ACH SPP',
    ecdc: 'ACHSPP',
    index: 47
  },
  {
    value: 'ACI BAU - Acinetobacter baumannii',
    code: 'ACI BAU',
    ecdc: 'ACIBAU',
    index: 48
  },
  {
    value: 'ACI AUT - Acinetobacter autres',
    code: 'ACI AUT',
    ecdc: 'ACIOTH',
    index: 49
  },
  {
    value: 'AEM SPP - Aeromonas',
    code: 'AEM SPP',
    ecdc: 'AEMSPP',
    index: 50
  },
  {
    value: 'AGR SPP - Agrobacterium',
    code: 'AGR SPP',
    ecdc: 'AGRSPP',
    index: 51
  },
  {
    value: 'ALC SPP - Alcaligenes',
    code: 'ALC SPP',
    ecdc: 'ALCSPP',
    index: 52
  },
  {
    value: 'BUR CEP - Burkholderia cepacia',
    code: 'BUR CEP',
    ecdc: 'BURCEP',
    index: 53
  },
  {
    value: 'CAM SPP - Campylobacter',
    code: 'CAM SPP',
    ecdc: 'CAMSPP',
    index: 54
  },
  {
    value: 'FLA SPP - Flavobacterium',
    code: 'FLA SPP',
    ecdc: 'FLASPP',
    index: 55
  },
  {
    value: 'GAR SPP - Gardnerella',
    code: 'GAR SPP',
    ecdc: 'GARSPP',
    index: 56
  },
  {
    value: 'HAE SPP - Haemophilus',
    code: 'HAE SPP',
    ecdc: 'HAESPP',
    index: 57
  },
  {
    value: 'HEL PYL - Helicobacter pylori',
    code: 'HEL PYL',
    ecdc: 'HELPYL',
    index: 58
  },
  {
    value: 'LEG SPP - Legionella',
    code: 'LEG SPP',
    ecdc: 'LEGSPP',
    index: 59
  },
  {
    value: 'PAS SPP - Pasteurella',
    code: 'PAS SPP',
    ecdc: 'PASSPP',
    index: 60
  },
  {
    value: 'PSE AER - Pseudomonas aeruginosa',
    code: 'PSE AER',
    ecdc: 'PSEAER',
    index: 61
  },
  {
    value: 'PSE AUT - Pseudomonas autres et apparentés',
    code: 'PSE AUT',
    ecdc: 'PSEOTH',
    index: 62
  },
  {
    value: 'STE MAL - Stenotrophomonas maltophilia',
    code: 'STE MAL',
    ecdc: 'STEMAL',
    index: 63
  },
  {
    value: 'BGN AUT - Bacille Gram- non entérobactérale autres',
    code: 'BGN AUT',
    ecdc: 'GNBOTH',
    index: 64
  },
  {
    value: 'BAT FRA - Bacteroïdes fragilis',
    code: 'BAT FRA',
    ecdc: 'BATFRA',
    index: 65
  },
  {
    value: 'BAT AUT - Bacteroïdes autres',
    code: 'BAT AUT',
    ecdc: 'BATOTH',
    index: 66
  },
  {
    value: 'CLO DIF - Clostridium difficile',
    code: 'CLO DIF',
    ecdc: 'CLODIF',
    index: 67
  },
  {
    value: 'CLO AUT - Clostridium autres',
    code: 'CLO AUT',
    ecdc: 'CLOOTH',
    index: 68
  },
  {
    value: 'PRE SPP - Prevotella',
    code: 'PRE SPP',
    ecdc: 'PRESPP',
    index: 69
  },
  {
    value: 'PRO SPP - Propionibacterium',
    code: 'PRO SPP',
    ecdc: 'PROSPP',
    index: 70
  },
  {
    value: 'ANA AUT - Anaérobies : autres',
    code: 'ANA AUT',
    ecdc: 'ANAOTH',
    index: 71
  },
  {
    value: 'ACT SPP - Actinomyces',
    code: 'ACT SPP',
    ecdc: 'ACTSPP',
    index: 72
  },
  {
    value: 'CHL SPP - Chlamydia',
    code: 'CHL SPP',
    ecdc: 'CHLSPP',
    index: 73
  },
  {
    value: 'MYC ATY - Mycobactérie atypique',
    code: 'MYC ATY',
    ecdc: 'MYCATY',
    index: 74
  },
  {
    value: 'MYC TUB - Mycobacterium complex tuberculosis',
    code: 'MYC TUB',
    ecdc: 'MYCTUB',
    index: 75
  },
  {
    value: 'MYP SPP - Mycoplasma',
    code: 'MYP SPP',
    ecdc: 'MYPSPP',
    index: 76
  },
  {
    value: 'NOC SPP - Nocardia',
    code: 'NOC SPP',
    ecdc: 'NOCSPP',
    index: 77
  },
  {
    value: 'BCT AUT - Bactéries autres',
    code: 'BCT AUT',
    ecdc: 'BCTOTH',
    index: 78
  },
  {
    value: 'CAN ALB - Candida albicans',
    code: 'CAN ALB',
    ecdc: 'CANALB',
    index: 79
  },
  {
    value: 'CAN AUR - Candida auris',
    code: 'CAN AUR',
    ecdc: 'CANAUR',
    index: 80
  },
  {
    value: 'CAN GLA - Candida glabrata',
    code: 'CAN GLA',
    ecdc: 'CANGLA',
    index: 81
  },
  {
    value: 'CAN KRU - Candida krusei',
    code: 'CAN KRU',
    ecdc: 'CANKRU',
    index: 82
  },
  {
    value: 'CAN PAR - Candida parapsilosis',
    code: 'CAN PAR',
    ecdc: 'CANPAR',
    index: 83
  },
  {
    value: 'CAN TRO - Candida tropicalis',
    code: 'CAN TRO',
    ecdc: 'CANTRO',
    index: 84
  },
  {
    value: 'CAN AUT - Candida autres',
    code: 'CAN AUT',
    ecdc: 'CANOTH',
    index: 85
  },
  {
    value: 'ASP FUM - Aspergillus fumigatus',
    code: 'ASP FUM',
    ecdc: 'ASPFUM',
    index: 86
  },
  {
    value: 'ASP AUT - Aspergillus autres',
    code: 'ASP AUT',
    ecdc: 'ASPOTH',
    index: 87
  },
  {
    value: 'LEV AUT - Levures autres',
    code: 'LEV AUT',
    ecdc: 'YEAOTH',
    index: 88
  },
  {
    value: 'FIL AUT - Filaments autres',
    code: 'FIL AUT',
    ecdc: 'FILOTH',
    index: 89
  },
  {
    value: 'PAR AUT - Parasites autres',
    code: 'PAR AUT',
    ecdc: 'PAROTH',
    index: 90
  },
  {
    value: 'VIR ADV - Adenovirus',
    code: 'VIR ADV',
    ecdc: 'VIRADV',
    index: 91
  },
  {
    value: 'VIR CMV - CMV (cytomégalovirus)',
    code: 'VIR CMV',
    ecdc: 'VIRCMV',
    index: 92
  },
  {
    value: 'VIR ENT - Enterovirus (polio, coxsackie, echo)',
    code: 'VIR ENT',
    ecdc: 'VIRENT',
    index: 93
  },
  {
    value: 'VIR INF - Grippe (influenzae)',
    code: 'VIR INF',
    ecdc: 'VIRINF',
    index: 94
  },
  {
    value: 'VIR HAV - Hépatite virale A',
    code: 'VIR HAV',
    ecdc: 'VIRHAV',
    index: 95
  },
  {
    value: 'VIR HBV - Hépatite virale B',
    code: 'VIR HBV',
    ecdc: 'VIRHBV',
    index: 96
  },
  {
    value: 'VIR HCV - Hépatite virale C',
    code: 'VIR HCV',
    ecdc: 'VIRHCV',
    index: 97
  },
  {
    value: 'VIR ROT - Rotavirus',
    code: 'VIR ROT',
    ecdc: 'VIRROT',
    index: 98
  },
  {
    value: `VIR VIH - VIH (virus de l'immunodéficience humaine)`,
    code: 'VIR VIH',
    ecdc: 'VIRHIV',
    index: 99
  },
  {
    value: 'VIR HSV - Herpès simplex Virus',
    code: 'VIR HSV',
    ecdc: 'VIRHSV',
    index: 100
  },
  {
    value: 'VIR VZV - Varicello-zonateux Virus',
    code: 'VIR VZV',
    ecdc: 'VIRVZV',
    index: 101
  },
  {
    value: 'VIR VRS - VRS (virus respiratoire syncitial)',
    code: 'VIR VRS',
    ecdc: 'VIRRSV',
    index: 102
  },
  {
    value: 'VIR AUT - Virus autres',
    code: 'VIR AUT',
    ecdc: 'VIROTH',
    index: 103
  },
  {
    value: 'NON IDE - Micro-organisme non identifié ou non retrouvé',
    code: 'NON IDE',
    ecdc: '_NONID',
    index: 104
  },
  {
    value: 'NON EFF - Examen non effectué',
    code: 'NON EFF',
    ecdc: '_NOEXA',
    index: 105
  },
  {
    value: 'EXA STE - Examen stérile',
    code: 'EXA STE',
    ecdc: '_STERI',
    index: 106
  }
]

const completeList = {
  v1: initialList,
  v2: initialList.concat(
    [
      {
        value: 'PAN SPP - Pantoea SPP',
        code: 'PAN SPP',
        ecdc: 'ENBOTH',
        index: 107
      },
      {
        value: 'VIR SAR - SARS-Co-V2',
        code: 'VIR SAR',
        ecdc: 'VIRSAR',
        index: 108
      }
    ]
  )
}

const virusList = [
  'EXA STE', 'NON EFF', 'VIR AUT', 'VIR VRS', 'VIR VZV', 'VIR HSV', 'VIR VIH',
  'VIR ROT', 'VIR ADV', 'VIR CMV', 'VIR ENT', 'VIR INF', 'VIR HAV', 'VIR HBV',
  'VIR HCV', 'VIR SAR'
]

const list = {
  v1: completeList.v1.filter(e => virusList.indexOf(e.code) === -1),
  v2: completeList.v2.filter(e => virusList.indexOf(e.code) === -1)
}

const resistances = {
  v1: [
    {
      field: 'oxa',
      index: 0,
      values: oxaList.v1
    },
    {
      field: 'c3g',
      index: 1,
      values: c3gList.v1
    },
    {
      field: 'flu',
      index: 2,
      values: fluList
    },
    {
      field: 'gly',
      index: 3,
      values: glyList.v1
    },
    {
      field: 'car',
      index: 4,
      values: carList.v1
    },
    {
      field: 'pan',
      index: 5,
      values: panList.v1
    },
    {
      field: 'rktg',
      index: 6,
      values: rktgList
    },
    {
      field: 'blse',
      index: 7,
      values: blseList
    },
    {
      field: 'epc',
      index: 8,
      values: epcList
    },
    {
      field: 'epcType',
      index: 9,
      values: epcTypeList
    },
    {
      field: 'caz',
      index: 10,
      values: cazList.v1
    },
    {
      field: 'ppc',
      index: 11,
      values: ppcList
    },
    {
      field: 'ppcType',
      index: 12,
      values: ppcTypeList
    },
    {
      field: 'epcType2',
      index: 13,
      values: epcTypeList
    },
    {
      field: 'ppcType2',
      index: 14,
      values: ppcTypeList
    }
  ],
  v2: [
    {
      field: 'oxa',
      index: 0,
      values: oxaList.v2
    },
    {
      field: 'c3g',
      index: 1,
      values: c3gList.v2
    },
    {
      field: 'flu',
      index: 2,
      values: fluList
    },
    {
      field: 'gly',
      index: 3,
      values: glyList.v2
    },
    {
      field: 'car',
      index: 4,
      values: carList.v2
    },
    {
      field: 'pan',
      index: 5,
      values: panList.v2
    },
    {
      field: 'rktg',
      index: 6,
      values: rktgList
    },
    {
      field: 'blse',
      index: 7,
      values: blseList
    },
    {
      field: 'epc',
      index: 8,
      values: epcList
    },
    {
      field: 'epcType',
      index: 9,
      values: epcTypeList
    },
    {
      field: 'caz',
      index: 10,
      values: cazList.v2
    },
    {
      field: 'ppc',
      index: 11,
      values: ppcList
    },
    {
      field: 'ppcType',
      index: 12,
      values: ppcTypeList
    },
    {
      field: 'epcType2',
      index: 13,
      values: epcTypeList
    },
    {
      field: 'ppcType2',
      index: 14,
      values: ppcTypeList
    }
  ]
}

const antibioCode = {
  v1: resistances.v1.reduce(
    (result, r) => {
      result[r.field] = r.index
      return result
    }, {}
  ),

  v2: resistances.v2.reduce(
    (result, r) => {
      result[r.field] = r.index
      return result
    }, {}
  )
}

const bmrBhre = (function () {
  function buildErg (t) {
    return {
      mo: `ERG (${t}`,
      name: `Enterococcus ${t} intermédiaire/résistant aux glycopeptides`
    }
  }

  const sarm = {
    mo: `SARM`,
    name: `Staphylococcus aureus résistant à la méticilline`
  }
  const gisa = {
    mo: `GISA`,
    name: `Staphylococcus aureus de sensibilité diminuée aux glycopeptides`
  }
  const erg = {
    both: buildErg('faecalis ou faecium'),
    faecium: buildErg('faecium'),
    faecalis: buildErg('faecalis')
  }
  const eblse = {
    mo: `EBLSE`,
    name: `Entérobactérales productrices de BLSE`
  }
  const epc = {
    mo: `EPC`,
    name: `Entérobactérales productrices de carbapénémase`
  }
  const abri = {
    mo: `ABRI`,
    name: `Acinetobacter baumannii intermédiaire/résistant à l'imipénème`
  }
  const parc = {
    mo: `PARC`,
    name: `Pseudomonas aeruginosa intermédiaire/résistant à la ceftazidime`
  }

  const list = {
    v1: [ sarm, gisa, erg.both, eblse, epc, abri, parc ],
    v2: [ sarm, gisa, erg.faecium, erg.faecalis, eblse, epc, abri, parc ]
  }

  function build (v) {
    const v2 = v === 'v2'
    const start = v2 ? 1 : 0

    const values = v2 ? [{ code: -1, value: '(Aucun)' }] : []
    list[v].forEach(
      (l, i) => {
        const index = start + i
        const t = `${l.mo} - ${l.name}`
        values.push(
          {
            code: index,
            mo: l.mo,
            value: v2 ? `${index} - ${t}` : t
          }
        )
      }
    )
    return values
  }

  return {
    v1: build('v1'),
    v2: build('v2')
  }
})()

const enterobacteria = [
  'CIT FRE', 'CIT KOS', 'CIT AUT', 'ENT AER', 'ENT CLO', 'ENT AUT', 'ESC COL',
  'HAF SPP', 'KLE OXY', 'KLE PNE', 'KLE AUT', 'MOG SPP', 'PRT MIR', 'PRT AUT',
  'PRV SPP', 'SAL TYP', 'SAL AUT', 'SER SPP', 'SHI SPP', 'ETB AUT', 'PAN SPP'
]

const candida = [
  'CAN ALB', 'CAN AUR', 'CAN GLA', 'CAN KRU', 'CAN PAR', 'CAN TRO', 'CAN AUT'
]

export default {
  oxaList: oxaList,
  glyList: glyList,
  panList: panList,
  c3gList: c3gList,
  carList: carList,
  fluList: fluList,
  rktgList: rktgList,
  blseList: blseList,
  epcList: epcList,
  epcTypeList: epcTypeList,
  ppcList: ppcList,
  ppcTypeList: ppcTypeList,
  cazList: cazList,
  list: list,
  completeList: completeList,
  resistances: resistances,
  antibioCode: antibioCode,
  bmrBhre: bmrBhre,
  enterobacteria: enterobacteria,
  candida: candida
}
